module.exports = __webpack_public_path__ + "img/index_main.1a1edc25.png";